import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;


import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/image-map.min.js';
import './lib/slick.min.js';
$(document).foundation();


// Slide Slick
$(document).ready(function(){
    $('.mySlider').slick({
        speed: 1000,
        autoplay: false,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        arrows: true
    });
  });

// Go top button
$(document).ready(function ($) {
    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = $(".cd-top");

    //hide or show the "back to top" link
    $(window).scroll(function () {
        $(this).scrollTop() > offset ?
            $back_to_top.addClass("cd-is-visible") :
            $back_to_top.removeClass("cd-is-visible cd-fade-out");
        if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass("cd-fade-out");
        }
    });
    //smooth scroll to top
    $back_to_top.on("click", function (event) {
        event.preventDefault();
        $("body,html").animate({
                scrollTop: 0
            },
            scroll_top_duration
        );
    });
});

// Pause and play videos when scroll
$(document).ready(function ($) {
    //videos youtube
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var videos = {
        es: {
            "1": "iIasg6CHfOI?rel=0",
            "2": "6wqyPhNcVTs?rel=0",
            "3": "FUjrowC1R1A?rel=0",
            "4": "WdAy_ie_FMY?rel=0"
        },
        ca: {
            "1": "NVmvuj2J-mU?rel=0",
            "2": "xXeDxIaEYz8?rel=0",
            "3": "69Q25zWS2MI?rel=0",
            "4": "XbGM0Ug1Y-A?rel=0"
        }
    };

    var player1, player2, player3, player4;
    var video1Ready = false,
        video2Ready = false,
        video3Ready = false,
        video4Ready = false;

    window.onYouTubeIframeAPIReady = function () {
        player1 = new YT.Player("video_1", {
            height: "315",
            width: "560",
            playerVars: {
                rel: 0
            },
            videoId: videos[$("html").attr("lang")]["1"],
            events: {
                onReady: function (event) {
                    video1Ready = true;
                }
            }
        });

        player2 = new YT.Player("video_2", {
            height: "315",
            width: "560",
            playerVars: {
                rel: 0
            },
            videoId: videos[$("html").attr("lang")]["2"],
            events: {
                onReady: function (event) {
                    video2Ready = true;
                }
            }
        });
        player3 = new YT.Player("video_3", {
            height: "315",
            width: "560",
            playerVars: {
                rel: 0
            },
            videoId: videos[$("html").attr("lang")]["3"],
            events: {
                onReady: function (event) {
                    video3Ready = true;
                }
            }
        });

        player4 = new YT.Player("video_4", {
            height: "315",
            width: "560",
            playerVars: {
                rel: 0
            },
            videoId: videos[$("html").attr("lang")]["4"],
            events: {
                onReady: function (event) {
                    video4Ready = true;
                }
            }
        });
        // VisSense
        if (document.getElementById("video_1")) {
            VisSense.VisMon.Builder(
                    VisSense(document.getElementById("video_1"), {
                        fullyvisible: 0.75
                    })
                )
                .on("fullyvisible", function () {
                    if (player1 != null && video1Ready) {
                        player1.playVideo();
                    }
                })
                .on("hidden", function () {
                    if (player1 != null && video1Ready && player1.getPlayerState() == 1) {
                        player1.pauseVideo();
                    }
                })
                .build()
                .start();
        }

        if (document.getElementById("video_2")) {
            VisSense.VisMon.Builder(
                    VisSense(document.getElementById("video_2"), {
                        fullyvisible: 0.75
                    })
                )
                .on("fullyvisible", function () {
                    if (player2 != null && video2Ready) {
                        player2.playVideo();
                    }
                })
                .on("hidden", function () {
                    if (player2 != null && video2Ready && player2.getPlayerState() == 1) {
                        player2.pauseVideo();
                    }
                })
                .build()
                .start();
        }

        if (document.getElementById("video_3")) {
            VisSense.VisMon.Builder(
                    VisSense(document.getElementById("video_3"), {
                        fullyvisible: 0.75
                    })
                )
                .on("fullyvisible", function () {
                    if (player3 != null && video3Ready) {
                        player3.playVideo();
                    }
                })
                .on("hidden", function () {
                    if (player3 != null && video3Ready && player3.getPlayerState() == 1) {
                        player3.pauseVideo();
                    }
                })
                .build()
                .start();
        }

        if (document.getElementById("video_4")) {
            VisSense.VisMon.Builder(
                    VisSense(document.getElementById("video_4"), {
                        fullyvisible: 0.75
                    })
                )
                .on("fullyvisible", function () {
                    if (player4 != null && video4Ready) {
                        player4.playVideo();
                    }
                })
                .on("hidden", function () {
                    if (player4 != null && video4Ready && player4.getPlayerState() == 1) {
                        player4.pauseVideo();
                    }
                })
                .build()
                .start();
        }
    };
});

// Imagemap
var mainApp = {

    setupImageMap: function () {
        $('img[usemap]').imageMap();
    },

    setupMouseOverLandingImg: function () {
        $('#coche-electrico').bind('mouseover', function () {
            mainApp.selectRegion('fourth');
        });
        $('#transporte-publico').bind('mouseover', function () {
            mainApp.selectRegion('third');
        });
        $('#bicicleta').bind('mouseover', function () {
            mainApp.selectRegion('second');
        });
        $('#andando').bind('mouseover', function () {
            mainApp.selectRegion('first');
        });

    },

    selectRegion: function (region) {
        $('#landing_img').attr('src', 'img/image-map-' + region + '.png');
    },

    setupOnClickLandingImg: function () {
        $('#coche-electrico').bind('click', function () {
            mainApp.selectRegionActive('fourth');
        });
        $('#transporte-publico').bind('click', function () {
            mainApp.selectRegionActive('third');
        });
        $('#bicicleta').bind('click', function () {
            mainApp.selectRegionActive('second');
        });
        $('#andando').bind('click', function () {
            mainApp.selectRegionActive('first');
        });

    },
    selectRegionActive: function (region) {
        $('#landing_img').attr('src', 'img/image-map-' + region + '-active' + '.png');
     
    },
    // Show info salut
    setupShowinfo: function () {
        $('.pink-button').bind('click', function () {
            $( '.media-block__img' ).removeClass( "hide" );
        });
      
    }

}
$(document).ready(function () { // functions
    mainApp.setupImageMap();
    mainApp.setupMouseOverLandingImg();
    mainApp.setupOnClickLandingImg();
    mainApp.setupShowinfo();
});

